import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import twitterIcon from "../../resources/img/twitter-icon.png";
import instagramIcon from "../../resources/img/instagram-icon.png";
import facebookIcon from "../../resources/img/facebook-icon.png";
import { TERMS_ROUTE, CONTACT_ROUTE, CONFIDENTIALITY_ROUTE } from '../../../SHARED/config/routes';

class Footer extends Component {

    getCurrYear = () => {
        const dt = new Date();
        return dt.getFullYear();
    };

    render() {
        return (
            <div className="footer text-center">
                <div className="container-fluid">
                    <div className="social-footer">
                        <div className="row">
                            <div className="footer-social-item">
                                <a href={process.env.REACT_APP_TWITTER_URL} target="_BLANK">
                                    <img src={ twitterIcon } alt={"Cinemap"} className="social-icon"/>
                                </a>
                            </div>
                            <div className="footer-social-item">
                                <a href={process.env.REACT_APP_INSTAGRAM_URL} target="_BLANK">
                                    <img src={ instagramIcon } alt={"Cinemap"} className="social-icon" />
                                </a>
                            </div>
                            <div className="footer-social-item">
                                <a href={process.env.REACT_APP_FACEBOOK_URL} target="_BLANK">
                                    <img src={ facebookIcon } alt={"Cinemap"} className="social-icon" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <span>Acest site folosește cookie-uri. Navigând în continuare, vă exprimați acordul asupra folosirii cookie-urilor. <Link to={CONFIDENTIALITY_ROUTE}>Află mai multe</Link></span>
                    <br/>
                    <span>Copyright© { this.getCurrYear() } Cinemap®</span>
                    <span>
                        <Link to={ TERMS_ROUTE }>Termeni şi condiţii </Link> |
                        <Link to={ CONTACT_ROUTE }> Contact</Link> |
                        <Link to={ CONFIDENTIALITY_ROUTE }> Politica de confidențialitate</Link>
                    </span>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
});
export default withRouter(connect(mapStateToProps, {})(Footer));



// WEBPACK FOOTER //
// ./src/FO/components/footer/footer.component.js